/* eslint-disable */
import {Service} from 'components/Shared/server';



export const routePostSubscribe = (email: string) => `/api/newsletter/subscribe?email=${encodeURIComponent(email)}`;
export function postSubscribe(email: string): Promise<Response> {
  return Service.post<Response>({
    url: routePostSubscribe(email),
    body: null
  });
}
